import { RepoBulkAction } from '@developerz/domain';
import { type JSX, Show } from 'solid-js';
import { t, tPlural } from '../i18n';
import type { RepoEnablementPicker } from '../lib/repo-enablement-picker';
import { count } from '../lib/time';
import { ConfirmDialog } from './ConfirmDialog';
import { RepoEnablementPace } from './RepoEnablementPace';
import { RepoEnablementRefusals } from './RepoEnablementRefusals';

// The one explicit act: the server's dry-run count, the pace, and what would be refused. Nothing has
// been written when this opens.

export function RepoEnablementConfirm(props: {
  readonly picker: RepoEnablementPicker;
}): JSX.Element {
  const pending = () => props.picker.pending();
  const applied = (): number => pending()?.dry.applied ?? 0;
  const enabling = (): boolean => pending()?.request.action === RepoBulkAction.Enable;
  return (
    <ConfirmDialog
      open={pending() !== null}
      title={
        enabling()
          ? tPlural('repo_enablement.confirm_enable_title', applied(), { shown: count(applied()) })
          : tPlural('repo_enablement.confirm_disable_title', applied(), { shown: count(applied()) })
      }
      desc={
        enabling()
          ? t('repo_enablement.confirm_enable_desc')
          : t('repo_enablement.confirm_disable_desc')
      }
      cancelLabel={t('repo_enablement.cancel')}
      actionLabel={
        enabling()
          ? t('repo_enablement.confirm_enable_cta', { n: count(applied()) })
          : t('repo_enablement.confirm_disable_cta', { n: count(applied()) })
      }
      destructive={!enabling()}
      onCancel={props.picker.cancel}
      onConfirm={props.picker.confirm}
    >
      <Show when={pending()}>
        {(asked) => (
          <>
            <RepoEnablementPace answer={asked().dry} />
            <RepoEnablementRefusals answer={asked().dry} />
          </>
        )}
      </Show>
    </ConfirmDialog>
  );
}
